import { Spinner } from "@chakra-ui/react"
import { GetGranularityConfiguration, Granularity } from "@hydrologiq/common/types/reporting/Granularity"
import { useQuery } from "@apollo/client"
import * as gqlTypes from "@hydrologiq/gql/graphql"
import { IANATimeZone, toTimestamp } from "@hydrologiq/common/helpers/date"
import { DateTime } from "timezonecomplete"
import Download from "@hydrologiq/shared/reporting/Download"
import { usageCsv, type RowType } from "@hydrologiq/shared/reporting/usageCsv"
interface InstallationUsageDownloadProps {
  start: DateTime
  end: DateTime
  granularity: Granularity
  installation: string
  installationName: string
  callback?: () => void
  selectedFields?: (keyof RowType)[]
}

function InstallationUsageDownload({
  start,
  end,
  installation,
  granularity,
  installationName,
  callback,
  selectedFields,
}: InstallationUsageDownloadProps) {
  const granularityConfig = GetGranularityConfiguration(granularity)

  const { loading, error, data } = useQuery(gqlTypes.GetInstallationUsageDocument, {
    variables: {
      id: installation,
      start: toTimestamp(start, true),
      end: toTimestamp(end, true),
      freq: granularityConfig.queryFrequency,
      tz: IANATimeZone(),
    },
  })

  if (loading) return <Spinner />
  if (error || !data) return "An error has occurred: " + error?.message

  return (
    <Download
      start={start}
      end={end}
      granularity={granularity}
      baseName={installationName}
      callback={callback}
      data={usageCsv(data.usage || [], selectedFields)}
    />
  )
}

export default InstallationUsageDownload
